import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { withRouter } from 'react-router-dom';
import configureStore from './configureStore';

let reduxStore;
class ProviderWithRouter extends React.Component {
  constructor(props) {
    super(props);

    this.store = configureStore(
      {},
      {
        routerHistory: props.history
      }
    );

    reduxStore = this.store;
  }

  static propTypes = {
    children: PropTypes.element.isRequired,
    history: PropTypes.object.isRequired
  };

  render() {
    return <Provider store={this.store}>{this.props.children}</Provider>;
  }
}

export default withRouter(ProviderWithRouter);

export const getValuationState = () => reduxStore.getState().valuation;



// WEBPACK FOOTER //
// ./src/ProviderWithRouter.js